import { getAuth, initializeAuth, indexedDBLocalPersistence, browserLocalPersistence } from 'firebase/auth';
import { isNativeApp } from './platform';

export function initializeERPAuth(app) {
  if (!isNativeApp()) return getAuth(app);
  // Native email/password login must not wait for a browser OAuth iframe.
  // Keep IndexedDB first so existing sessions can be restored after an update.
  return initializeAuth(app, {
    persistence: [indexedDBLocalPersistence, browserLocalPersistence]
  });
}
